<template>
  <el-drawer
    v-if="properties"
    size="700px"
    class="drawer"
    :visible.sync="visible"
    :show-close="false"
    style="text-align:left;"
    z-index="1000"
    @close="cancel"
  >
    <!-- 标题（发起人项的抽屉标题） -->
    <header
      v-if="value && value.type == 'start' && properties.title"
      slot="title"
      class="header"
    >
      {{ properties.title }}
    </header>
    <!--标题（非发起人的抽屉标题）（可被替换）-->
    <header v-else slot="title" class="header">
      <span
        v-show="!titleInputVisible"
        style="cursor:pointer;"
        @click="titleInputVisible = true"
      >
        {{ properties.title }}
        <i class="el-icon-edit"></i>
      </span>
      <el-input
        v-show="titleInputVisible"
        v-model="properties.title"
        v-clickoutside="_ => (titleInputVisible = false)"
        size="mini"
        style="z-index:9;max-width: 200px;"
      />
      <el-select
        v-if="isConditionNode()"
        v-model="properties.priority"
        size="mini"
        class="priority-select"
      >
        <el-option
          v-for="item in priorityLength"
          :key="item"
          :value="item - 1"
          :label="'优先级' + item"
        />
      </el-select>
    </header>

    <!-- 条件  -->
    <section v-if="value && isConditionNode()" class="condition-pane">
      <template v-for="(item, index) in conditions">
        <!-- 数字输入框 -->
        <row-wrapper
          v-if="couldShowIt(item, 'number')"
          :key="index"
          :title="item.label"
        >
          <num-input
            :key="index"
            v-model="item.conditionValue"
            :title="item.label"
            style="padding-right: 6px;"
          />
          <template v-slot:action>
            <i
              class="el-icon-delete"
              style="cursor: pointer;"
              @click="onDelCondition(item)"
            ></i>
          </template>
        </row-wrapper>
        <!-- 单选组 -->
        <row-wrapper
          v-if="couldShowIt(item, 'el-radio-group')"
          :key="index"
          :title="item.label"
        >
          <el-radio-group
            v-model="item.conditionValue.value"
            class="radio-group"
          >
            <el-radio
              v-for="item in item.options"
              :key="item.label"
              :label="item.label"
            >{{ item.label }}</el-radio>
          </el-radio-group>
          <template v-slot:action>
            <i
              class="el-icon-delete"
              style="cursor: pointer;"
              @click="onDelCondition(item)"
            ></i>
          </template>
        </row-wrapper>

        <!-- 下拉 -->
        <row-wrapper
          v-if="couldShowIt(item, 'select')"
          :key="index"
          :title="item.label"
        >
          <el-select
            v-model="item.conditionValue.value"
            placeholder="请选择"
            size="small"
          >
            <el-option
              v-for="item in item.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <template v-slot:action>
            <i
              class="el-icon-delete"
              style="cursor: pointer;"
              @click="onDelCondition(item)"
            ></i>
          </template>
        </row-wrapper>
        <!-- 组织机构(树状图选择) -->
        <row-wrapper
          v-if="couldShowIt(item, 'organization')"
          :key="index"
          :title="item.label"
        >
          <department-tree-select
            ref="organization"
            :dept-ids.sync="item.conditionValue.value"
            :multiple="item.multi"
            placeholder="请选择部门"
            z-index="1002"
          />
          <template v-slot:action>
            <i
              class="el-icon-delete"
              style="cursor: pointer;"
              @click="onDelCondition(item)"
            ></i>
          </template>
        </row-wrapper>
      </template>

      <div style="padding-left:10px;margin-top:2em;">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="dialogVisible = true"
        >添加条件</el-button>
        <span
          style="color:#aaa;margin-left:16px;"
        >还有{{ notUseConNum }}个可用条件</span>
      </div>
    </section>

    <!-- 审批人 -->
    <section
      v-if="value && (isApproverNode() || isStartNode())"
      class="approver-pane"
      style="height:100%;"
    >
      <!-- 开始节点 -->
      <el-row v-if="value.type === 'start'" style="padding: 10px;">
        <el-col :span="4" style="font-size: 12px;">发起人</el-col>
        <el-col :span="18" style="padding-left: 12px;">
          <fc-org-select
            ref="start-org"
            v-model="initiator"
            :tab-list="['dep&user']"
          />
        </el-col>
      </el-row>

      <div v-else-if="value.type === 'approver'">
        <div style="padding: 12px;">
          <el-radio-group
            v-model="approverForm.assigneeType"
            style="line-height: 32px;"
            @change="resetOrgColl"
          >
            <el-radio
              v-for="item in assigneeTypeOptions"
              :key="item.value"
              :label="item.value"
              class="radio-item"
            >{{ item.label }}</el-radio>
          </el-radio-group>
        </div>
        <div style="border-bottom: 1px solid #e5e5e5; padding-bottom: 1rem;">
          <!--设置审批人，主管-->
          <div v-if="approverForm.assigneeType === 'director'">
            <div style="font-size: 14px;padding-left: 1rem;">
              发起人所在部门的主管
            </div>
          </div>

          <!--设置审批人，指定成员、角色、岗位-->
          <div v-else class="option-box">
            <select-approver-dialog
              v-model="orgCollection.user"
              btn-text="选择审核人"
            />
          </div>
        </div>

        <!--多人审批时采用的审批方式-->
        <div
          v-if="showApproverMethodSelect"
          class="option-box p-t-10"
          style="border-bottom: 1px solid #e5e5e5;"
        >
          <p v-if="approverForm.assigneeType !== 'director'">
            多人审批时采用的审批方式
          </p>
          <p v-else>部门可能存在多名主管，请选择采用的审批方式</p>
          <el-radio-group v-model="approverForm.approverMethod">
            <template v-for="item in workflowAuditMethodDict.array">
              <el-radio
                :key="item.label"
                :label="item.value"
                class="radio-item"
              >{{ item.label }}（{{ item.desc }}）</el-radio>
              <br :key="`${item.label}-br`" />
            </template>
          </el-radio-group>
        </div>
      </div>
    </section>

    <!--抄送人节点-->
    <section v-if="value && isCopyNode()" style="padding-left: 1rem;">
      <p>抄送人：</p>
      <select-approver-dialog
        v-model="properties.members.user"
        btn-text="选择抄送人"
      />

      <p class="m-t-20">抄送部门：</p>
      <department-tree-select
        ref="copyOrganization"
        :dept-ids.sync="copyOrganizationIds"
        placeholder="请选择部门"
        z-index="1002"
      />
    </section>

    <!--条件选择器，点击添加条件按钮的弹窗-->
    <el-dialog
      title="选择条件"
      :visible.sync="dialogVisible"
      width="500px"
      :append-to-body="true"
      custom-class="condition-dialog"
    >
      <el-checkbox-group v-model="showingPCons">
        <el-checkbox
          v-for="(item, index) in conditions"
          :key="index"
          :label="item.code"
        >
          {{ item.label }}
        </el-checkbox>
      </el-checkbox-group>
    </el-dialog>

    <div class="actions">
      <el-button size="small" @click="cancel">取消</el-button>
      <el-button size="small" type="primary" @click="confirm">确定</el-button>
    </div>
  </el-drawer>
</template>

<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'
import { NodeUtils } from '../FlowCard/util.js'
import RowWrapper from './RowWrapper'
import NumInput from './NumInput'
import DepartmentTreeSelect from '@/components/common/DepartmentTreeSelect'
import SelectApproverDialog from '@/components/workflow/Process/PropPanel/SelectApproverDialog'
import { cloneDeep } from 'lodash'

// 引入数据字典
import { workflowAuditMethodDict } from '@/dictionary/workflow'

const rangeType = {
  lt: '<',
  le: '<=',
  gt: '>',
  ge: '>=',
  eq: '='
}

/**
 * 默认的审核配置表单
 */
const defaultApproverForm = {
  approvers: [], // 审批人集合
  assigneeType: 'user', // 指定审批人
  approverMethod: workflowAuditMethodDict.OR.value // 审批方式（默认或签）
}

export default {
  name: 'ProcessDrawer',

  directives: {
    Clickoutside
  },
  components: {
    NumInput,
    RowWrapper,
    DepartmentTreeSelect,
    SelectApproverDialog
  },

  props: {
    // 当前选中的流程节点数据
    value: {
      type: Object,
      default: null
    },

    // 整个流程图数据
    processData: {
      type: Object,
      default: null
    },

    // 条件表单数组
    conditionsList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      // 输入据字典
      workflowAuditMethodDict,

      visible: false, // 控制面板显隐
      titleInputVisible: false, // 是否显示标题输入框  startNode 不显示
      activeName: 'config', // or formAuth  Tab面板key
      showingPCons: [], // 用户选择了的条件  被选中的才会被展示在面板上编辑
      conditions: [], // 条件表单
      dialogVisible: false, // 控制流程条件选项Dialog显隐
      // 当前节点数据
      properties: {},
      // 发起人  start节点和condition节点需要
      initiator: {
        'dep&user': []
      },
      priorityLength: 0, // 当为条件节点时  显示节点优先级选项的数据
      orgCollection: {
        user: []
      },
      useDirectorProxy: true, // 找不到主管时 上级主管代理审批
      startForm: {
        formOperates: []
      },
      approverForm: JSON.parse(JSON.stringify(defaultApproverForm)),

      rangeOptions: [
        { label: '全公司', value: 'ALL' },
        { label: '指定成员', value: 'USER' },
        { label: '角色', value: 'ROLE' }
      ],

      assigneeTypeOptions: [
        { label: '指定成员', value: 'user' },
        { label: '部门主管', value: 'director' }
        // { label: '角色', value: 'role' }
      ]
    }
  },
  computed: {
    // 未使用的条件个数
    notUseConNum() {
      return this.conditions.length - this.showingPCons.length
    },

    // 是否需要选择或签/会签
    showApproverMethodSelect() {
      return (
        (this.orgCollection[this.approverForm.assigneeType] &&
          this.orgCollection[this.approverForm.assigneeType].length > 1) ||
        this.approverForm.assigneeType === 'director'
      )
    },

    // 抄送部门
    copyOrganizationIds: {
      get() {
        return (this.properties?.members?.dept || []).map(value => value.id)
      },
      set(val) {
        this.properties.members.dept = val.map(id => {
          return {
            id: id,
            name: this.$refs.copyOrganization.getLabelListByDeptIds(id)[0] || ''
          }
        })
      }
    }
  },

  watch: {
    visible(val) {
      if (!val) {
        this.approverForm = JSON.parse(JSON.stringify(defaultApproverForm)) // 重置数据为默认状态
        return
      }

      this.isStartNode() && this.initStartNodeData()
      this.isApproverNode() && this.initApproverNodeData()
      this.isConditionNode() && this.initConditionNodeData()
    },

    value(newVal) {
      if (newVal && newVal.properties) {
        this.visible = true
        this.properties = JSON.parse(JSON.stringify(newVal.properties))
        if (this.properties) {
          NodeUtils.isConditionNode(newVal) && this.getPriorityLength()
        }
      }
    }
  },
  methods: {
    resetOrgColl() {
      // for (const key in this.orgCollection) {
      //   this.$set(this.orgCollection, key, [])
      // }
    },

    onOrgChange(data) {},

    getAssignTypeLabel() {
      const res = this.assigneeTypeOptions.find(
        t => t.value === this.approverForm.assigneeType
      )
      return res ? res.label : ''
    },

    // 是否可以显示当前条件组件
    couldShowIt(item, ...tag) {
      return tag.includes(item.type) && this.showingPCons.includes(item.code)
    },

    initCopyNode() {
      this.properties = this.value.properties
    },

    initStartNodeData() {
      this.initInitiator()
    },

    /**
     * 保存抄送人节点
     */
    copyNodeConfirm() {
      let content = ''
      if (this.properties?.members?.user?.length) {
        content =
          '抄送人：' +
          this.properties.members.user.map(value => value.name).join('，')
      }
      if (this.properties?.members?.dept?.length) {
        if (content) content += '；\n'
        content +=
          '抄送部门：' +
          this.properties.members.dept.map(value => value.name).join('，')
      }

      this.$emit('confirm', this.properties, content || '请选择抄送人')
      this.visible = false
    },

    /**
     * 条件节点确认保存得回调
     */
    conditionNodeConfirm() {
      let nodeContent = ''
      const conditions = cloneDeep(
        this.showingPCons.map(code =>
          this.conditions.find(t => t.code === code && t.conditionValue.value)
        )
      )

      conditions.forEach((t, index) => {
        index += 1
        if (!t) return // 发起人条件时 t 为空 发起人在其他地方获取
        if (nodeContent) nodeContent += '；\n'

        if (t.type === 'select') {
          if (!t.options || !t.conditionValue.value) return

          if (!Array.isArray(t.conditionValue.value)) {
            t.conditionValue.value = [t.conditionValue.value]
          }
          if (t.conditionValue.value.length > 1) {
            t.conditionValue.type = 'or'
          }

          nodeContent += `${index}、${t.label} = `
          nodeContent += t.conditionValue.value
            .map(value => t.options.find(option => option.value === value))
            .map(value => value.label)
            .join('、')
        }

        if (t.type === 'number') {
          if (t.conditionValue.type === 'bet') {
            const temp = t.conditionValue.value
            nodeContent += `${index}、${temp[0]}${t.unit || ''} ${temp[1]} ${
              t.label
            } ${temp[2]} ${temp[3]}${t.unit || ''}`
          } else {
            if (!Array.isArray(t.conditionValue.value)) {
              t.conditionValue.value = [t.conditionValue.value]
            }

            nodeContent =
              nodeContent +
              `${index}、${t.label} ${rangeType[t.conditionValue.type]} ${
                t.conditionValue.value[0]
              } ${t.unit || ''}`
          }
        }

        if (t.type === 'organization') {
          if (!t.conditionValue.value) return

          if (!Array.isArray(t.conditionValue.value)) {
            t.conditionValue.value = [t.conditionValue.value]
          }
          if (t.conditionValue.value.length > 1) {
            t.conditionValue.type = 'or'
          }

          const nameList =
            this.$refs.organization[0].getLabelListByDeptIds(
              t.conditionValue.value
            ) || []
          nodeContent += `${index}、${t.label}：${nameList.join('、')}`
          // t.conditionValue.value = t.conditionValue.value.map(value => value.id)
        }
      })

      this.properties.conditions = conditions

      this.$emit(
        'confirm',
        this.properties,
        nodeContent || '其他情况进入此流程'
      )
      this.visible = false
    },

    getOrgSelectLabel(type) {
      return this.$refs[type + '-org']['selectedLabels']
    },

    /**
     * 开始节点确认保存
     */
    startNodeConfirm() {
      this.properties.initiator = this.initiator['dep&user']

      this.$emit(
        'confirm',
        this.properties,
        this.getOrgSelectLabel('start') || '所有人'
      )
      this.visible = false
    },

    /**
     * 审批节点确认保存
     */
    approverNodeConfirm() {
      const assigneeType = this.approverForm.assigneeType
      let content = ''

      content +=
        this.assigneeTypeOptions.filter(dict => dict.value === assigneeType)[0]
          ?.label || ''

      if (assigneeType !== 'director') {
        content =
          content +
          '：' +
          this.orgCollection[assigneeType].map(value => value.name).join(', ')
      }

      if (this.showApproverMethodSelect) {
        content += `（${workflowAuditMethodDict.translate(
          this.approverForm.approverMethod
        )?.label || ''}）`
      }

      this.approverForm.approvers = this.orgCollection[assigneeType]
      Object.assign(this.properties, this.approverForm)
      this.$emit('confirm', this.properties, content || '请设置审批人')
      this.visible = false
    },

    // 确认修改
    confirm() {
      this.isCopyNode() && this.copyNodeConfirm()
      this.isStartNode() && this.startNodeConfirm()
      this.isApproverNode() && this.approverNodeConfirm()
      this.isConditionNode() && this.conditionNodeConfirm()
    },

    // 关闭抽屉
    cancel() {
      setTimeout(() => {
        this.$emit('cancel')
        this.visible = false
      }, 0)
    },

    /**
     * 删除流程条件
     */
    onDelCondition(condition) {
      const index = this.showingPCons.findIndex(code => code === condition.code)
      if (index > -1) {
        this.showingPCons.splice(index, 1)
        this.conditions.find(t => t.code === condition.code).conditionValue = {
          type: 'eq',
          value: ''
        }
      }
    },
    // 配合getPriorityLength 获取前一个节点条件数组长度 用于设置优先级
    getPrevData() {
      return NodeUtils.getPreviousNode(this.value.prevNodeId, this.processData)
    },
    // 用于获取节点优先级范围
    getPriorityLength() {
      this.priorityLength = this.getPrevData().conditionNodes.length
    },
    // 判断是否是条件节点
    isConditionNode() {
      return this.value ? NodeUtils.isConditionNode(this.value) : false
    },
    /** 判断是否是审批节点*/
    isApproverNode() {
      return this.value ? NodeUtils.isApproverNode(this.value) : false
    },

    isStartNode() {
      return this.value ? NodeUtils.isStartNode(this.value) : false
    },

    isCopyNode() {
      return this.value ? NodeUtils.isCopyNode(this.value) : false
    },

    initInitiator() {
      const initiator = this.value.properties && this.value.properties.initiator
      this.initiator['dep&user'] = Array.isArray(initiator) ? initiator : []
    },

    /**
     * 初始化审批节点所需数据
     */
    initApproverNodeData() {
      for (const key in this.approverForm) {
        // eslint-disable-next-line no-prototype-builtins
        if (this.value.properties.hasOwnProperty(key)) {
          this.approverForm[key] = this.value.properties[key]
        }
      }
      const approvers = this.approverForm.approvers
      this.resetOrgColl()
      if (Array.isArray(approvers)) {
        this.orgCollection[this.approverForm.assigneeType] = [...approvers]
      }
    },

    /**
     * 初始化条件节点数据
     */
    initConditionNodeData() {
      this.showingPCons = []
      this.conditions = this.conditionsList

      // 初始化条件表单数据
      const nodeConditions =
        this.value.properties && this.value.properties.conditions

      this.initiator['dep&user'] = this.value.properties.initiator
      if (Array.isArray(this.conditions)) {
        this.conditions.forEach(t => {
          let temp = { type: 'eq', value: '' }
          if (Array.isArray(nodeConditions)) {
            const con = cloneDeep(
              nodeConditions.find(item => item.code == t.code)
            )

            if (t.type === 'organization' && con?.conditionValue?.value) {
              con.conditionValue.value = con.conditionValue.value.map(id =>
                Number(id)
              )
            }
            if (con?.conditionValue?.value && !t.multi) {
              if (t.type === 'number' && con?.conditionValue?.type === 'bet') {
                //
              } else {
                con.conditionValue.value = con.conditionValue.value[0]
              }
            }

            con &&
              con.conditionValue &&
              ((temp = con.conditionValue), this.showingPCons.push(t.code))
          }

          this.$set(t, 'conditionValue', temp)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.drawer {
  ::v-deep .el-drawer__header {
    margin-bottom: 0;
    border-bottom: 1px solid $border-color;
    padding-bottom: 8px;
  }

  ::v-deep .el-drawer__body {
    padding-bottom: 44px;
    overflow: hidden;
  }

  .pane-tab {
    height: 100%;
  }

  .pane-tab ::v-deep .el-tabs__item.is-top:nth-child(2) {
    padding-left: 20px;
  }

  ::v-deep .el-tabs__item:focus {
    box-shadow: none !important;
  }

  ::v-deep .el-tabs__header {
    margin-bottom: 0;
  }
}

.header {
  line-height: 28px;
}

.actions {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 6px 12px;
  width: 100%;
  box-sizing: border-box;
  text-align: right;
}

.radio-item {
  width: 110px;
  padding: 6px;
}

.priority-select {
  width: 118px;
  position: absolute;
  right: 26px;
}

.form-auth-table {
  font-size: 14px;
  .auth-table-header {
    background: #fafafa;
    line-height: 40px;
  }
  .row {
    display: flex;
    align-items: center;
    line-height: 32px;
    padding: 8px 12px;
    border-bottom: 1px solid $border-color;
    &:hover {
      background: #f5f7fa;
    }
    .label {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      .required {
        color: $danger-color;
      }
    }
    .radio-group {
      flex: 2;
      display: flex;
      justify-content: space-between;
    }
  }
}

.approver-pane {
  overflow-y: scroll;
  overflow-x: hidden;
  .option-box {
    font-size: 14px;
    padding-left: 1rem;
  }
}

.condition-pane {
  height: 100%;
  overflow: scroll;
}

.condition-dialog {
  ::v-deep .el-dialog__header {
    border-bottom: 1px solid $border-color;
  }
}
</style>
